"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateReportingOutputDocxConfig = void 0;
const validateReportingOutputDocxConfig = (params) => {
    const { name, fundingRequestComponents } = params.config;
    const errors = [];
    if (name.length === 0) {
        errors.push(`Reporting output name cannot be empty`);
    }
    if (fundingRequestComponents &&
        Object.entries(fundingRequestComponents).every(([_k, value]) => !value)) {
        errors.push('Remove optional funding request component config or select at least one component type');
    }
    return errors;
};
exports.validateReportingOutputDocxConfig = validateReportingOutputDocxConfig;
//# sourceMappingURL=outputDocxConfigValidate.js.map